module.exports = __webpack_public_path__ + "media/请帅哥换位思考2.043fa4f8.mp3";